<template>
  <div class="cws-container blog-wrapper">
    <div>
      <b-row>
        <b-col md="12" lg="12">
          <b-card
              title="SIQ Анализ"
              class="mb-3"
              border-variant="primary"
          >
            <b-card-text>
              Загрузка SIQ-файла для анализа пакета
            </b-card-text>

            <b-form-group
                label="SIQ-Файл"
                label-for="siq-file"
            >
              <b-button
                  variant="outline-primary"
                  @click="$refs.refInputUploadFile.click()"
              >
                <input
                    ref="refInputUploadFile"
                    type="file"
                    class="d-none"
                    id="siq-file"
                    @input="inputSiqFileRenderer"
                />
                <span class="d-none d-sm-inline">Upload</span>
                <feather-icon
                    icon="UploadIcon"
                    class="d-inline d-sm-none"
                />
              </b-button>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- content -->
    <div class="blog-detail-wrapper">
      <b-row v-if="analysisData">
        <b-col cols="12">
          <b-overlay
              :show="isLoading"
              rounded="sm"
          >
            <b-card>
              <h2 class="mb-1">{{ analysisData.title }}</h2>
              <p class="text-muted mb-2">
                Автор: <strong>{{ analysisData.author }}</strong> |
                Всего песен: <strong>{{ analysisData.total_songs }}</strong>
              </p>

              <b-row class="mt-2">
                <!-- Русские / Иностранные -->
                <b-col md="4" cols="12">
                  <b-card title="По стране исполнителя" class="mb-2">
                    <vue-apex-charts
                        type="donut"
                        height="300"
                        :options="artistsCountryChartOptions"
                        :series="artistsCountrySeries"
                    />
                    <!-- Списки песен -->
                    <b-row class="mt-2 songs-lists">
                      <b-col cols="6">
                        <h6 class="text-russian mb-1">Русские ({{ russianSongs.length }})</h6>
                        <div class="songs-scroll">
                          <div
                              v-for="song in russianSongs"
                              :key="'ru-' + song.index"
                              class="song-item text-russian"
                          >
                            <small>{{ song.artist }} - {{ song.title }}</small>
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="6">
                        <h6 class="text-foreign mb-1">Иностранные ({{ foreignSongs.length }})</h6>
                        <div class="songs-scroll">
                          <div
                              v-for="song in foreignSongs"
                              :key="'foreign-' + song.index"
                              class="song-item text-foreign"
                          >
                            <small>{{ song.artist }} - {{ song.title }}</small>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>

                <!-- Рок / Другие жанры -->
                <b-col md="4" cols="12">
                  <b-card title="По жанру" class="mb-2">
                    <vue-apex-charts
                        type="donut"
                        height="300"
                        :options="genreChartOptions"
                        :series="genreSeries"
                    />
                    <!-- Списки песен -->
                    <b-row class="mt-2 songs-lists">
                      <b-col cols="6">
                        <h6 class="text-rock mb-1">Рок ({{ rockSongs.length }})</h6>
                        <div class="songs-scroll">
                          <div
                              v-for="song in rockSongs"
                              :key="'rock-' + song.index"
                              class="song-item text-rock"
                          >
                            <small>{{ song.artist }} - {{ song.title }}</small>
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="6">
                        <h6 class="text-other mb-1">Другие ({{ otherGenreSongs.length }})</h6>
                        <div class="songs-scroll">
                          <div
                              v-for="song in otherGenreSongs"
                              :key="'other-' + song.index"
                              class="song-item text-other"
                          >
                            <small>{{ song.artist }} - {{ song.title }}</small>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>

                <!-- 20 век / 21 век -->
                <b-col md="4" cols="12">
                  <b-card title="По эпохе" class="mb-2">
                    <vue-apex-charts
                        type="donut"
                        height="300"
                        :options="centuryChartOptions"
                        :series="centurySeries"
                    />
                    <!-- Списки песен -->
                    <b-row class="mt-2 songs-lists">
                      <b-col cols="6">
                        <h6 class="text-century20 mb-1">XX век ({{ century20Songs.length }})</h6>
                        <div class="songs-scroll">
                          <div
                              v-for="song in century20Songs"
                              :key="'c20-' + song.index"
                              class="song-item text-century20"
                          >
                            <small>{{ song.artist }} - {{ song.title }}</small>
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="6">
                        <h6 class="text-century21 mb-1">XXI век ({{ century21Songs.length }})</h6>
                        <div class="songs-scroll">
                          <div
                              v-for="song in century21Songs"
                              :key="'c21-' + song.index"
                              class="song-item text-century21"
                          >
                            <small>{{ song.artist }} - {{ song.title }}</small>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-overlay>
        </b-col>
      </b-row>

      <b-row v-else>
        <b-col cols="12">
          <b-overlay
              :show="isLoading"
              rounded="sm"
          >
            <b-card
                title="Данных нет"
                class="col-md-12 col-12"
            >
              <b-card-text>
                Загрузите SIQ-файл для анализа
              </b-card-text>
            </b-card>
          </b-overlay>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BFormGroup,
  BCard,
  BRow,
  BCol,
  BCardText,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from "@/store";
import musicStoreModule from "@/views/db-music/musicStoreModule";
import {onUnmounted, ref, computed} from "@vue/composition-api";
import {useToast} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {useInputImageRenderer} from "@core/comp-functions/forms/form-utils";
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BCardText,
    BButton,
    BOverlay,
    VueApexCharts,
  },
  directives: {
    Ripple,
  },
  setup() {
    const STORE_MODULE_NAME = 'playlist'
    const toast = useToast()

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, musicStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const analysisData = ref(null)
    const isLoading = ref(false)
    const refInputUploadFile = ref(null)

    // Chart colors
    const chartColors = {
      russian: '#28c76f',
      foreign: '#7367f0',
      rock: '#ff9f43',
      other: '#00cfe8',
      century20: '#ea5455',
      century21: '#82868b',
    }

    // Фильтрация песен по категориям
    const russianSongs = computed(() => {
      if (!analysisData.value || !analysisData.value.songs) return []
      return analysisData.value.songs.filter(s => s.is_russian)
    })

    const foreignSongs = computed(() => {
      if (!analysisData.value || !analysisData.value.songs) return []
      return analysisData.value.songs.filter(s => !s.is_russian)
    })

    const rockSongs = computed(() => {
      if (!analysisData.value || !analysisData.value.songs) return []
      return analysisData.value.songs.filter(s => s.is_rock)
    })

    const otherGenreSongs = computed(() => {
      if (!analysisData.value || !analysisData.value.songs) return []
      return analysisData.value.songs.filter(s => !s.is_rock)
    })

    const century20Songs = computed(() => {
      if (!analysisData.value || !analysisData.value.songs) return []
      return analysisData.value.songs.filter(s => s.century <= 20)
    })

    const century21Songs = computed(() => {
      if (!analysisData.value || !analysisData.value.songs) return []
      return analysisData.value.songs.filter(s => s.century >= 21)
    })

    // Русские / Иностранные исполнители
    const artistsCountrySeries = computed(() => {
      if (!analysisData.value || !analysisData.value.analysis) return [0, 0]
      return [
        analysisData.value.analysis.russian_artists_count,
        analysisData.value.analysis.foreign_artists_count,
      ]
    })

    const artistsCountryChartOptions = computed(() => ({
      legend: {
        show: true,
        position: 'bottom',
        fontSize: '14px',
        fontFamily: 'Montserrat',
      },
      colors: [chartColors.russian, chartColors.foreign],
      labels: ['Русские', 'Иностранные'],
      dataLabels: {
        enabled: true,
        formatter(val) {
          return `${parseInt(val)}%`
        },
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                fontSize: '1.5rem',
                fontFamily: 'Montserrat',
              },
              value: {
                fontSize: '1rem',
                fontFamily: 'Montserrat',
              },
              total: {
                show: true,
                fontSize: '1rem',
                label: 'Всего',
                formatter() {
                  if (!analysisData.value || !analysisData.value.analysis) return '0'
                  return analysisData.value.analysis.russian_artists_count +
                      analysisData.value.analysis.foreign_artists_count
                },
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 576,
          options: {
            chart: {
              height: 280,
            },
          },
        },
      ],
    }))

    // Рок / Другие жанры
    const genreSeries = computed(() => {
      if (!analysisData.value || !analysisData.value.analysis) return [0, 0]
      return [
        analysisData.value.analysis.rock_artists_count,
        analysisData.value.analysis.other_genres_count,
      ]
    })

    const genreChartOptions = computed(() => ({
      legend: {
        show: true,
        position: 'bottom',
        fontSize: '14px',
        fontFamily: 'Montserrat',
      },
      colors: [chartColors.rock, chartColors.other],
      labels: ['Рок', 'Другие жанры'],
      dataLabels: {
        enabled: true,
        formatter(val) {
          return `${parseInt(val)}%`
        },
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                fontSize: '1.5rem',
                fontFamily: 'Montserrat',
              },
              value: {
                fontSize: '1rem',
                fontFamily: 'Montserrat',
              },
              total: {
                show: true,
                fontSize: '1rem',
                label: 'Всего',
                formatter() {
                  if (!analysisData.value || !analysisData.value.analysis) return '0'
                  return analysisData.value.analysis.rock_artists_count +
                      analysisData.value.analysis.other_genres_count
                },
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 576,
          options: {
            chart: {
              height: 280,
            },
          },
        },
      ],
    }))

    // 20 век / 21 век
    const centurySeries = computed(() => {
      if (!analysisData.value || !analysisData.value.analysis) return [0, 0]
      return [
        analysisData.value.analysis.songs_20th_century,
        analysisData.value.analysis.songs_21st_century,
      ]
    })

    const centuryChartOptions = computed(() => ({
      legend: {
        show: true,
        position: 'bottom',
        fontSize: '14px',
        fontFamily: 'Montserrat',
      },
      colors: [chartColors.century20, chartColors.century21],
      labels: ['XX век', 'XXI век'],
      dataLabels: {
        enabled: true,
        formatter(val) {
          return `${parseInt(val)}%`
        },
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                fontSize: '1.5rem',
                fontFamily: 'Montserrat',
              },
              value: {
                fontSize: '1rem',
                fontFamily: 'Montserrat',
              },
              total: {
                show: true,
                fontSize: '1rem',
                label: 'Всего',
                formatter() {
                  if (!analysisData.value || !analysisData.value.analysis) return '0'
                  return analysisData.value.analysis.songs_20th_century +
                      analysisData.value.analysis.songs_21st_century
                },
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 576,
          options: {
            chart: {
              height: 280,
            },
          },
        },
      ],
    }))

    const {inputImageRenderer: inputSiqFileRenderer} = useInputImageRenderer(refInputUploadFile, async base64 => {
      const file = refInputUploadFile.value.files[0]
      isLoading.value = true
      try {
        const res = await store.dispatch('playlist/sigameAnalyze', {file: file})
        analysisData.value = res.data
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка загрузки файла',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        isLoading.value = false
      }
    })

    return {
      analysisData,
      isLoading,
      inputSiqFileRenderer,
      refInputUploadFile,
      artistsCountrySeries,
      artistsCountryChartOptions,
      genreSeries,
      genreChartOptions,
      centurySeries,
      centuryChartOptions,
      // Списки песен
      russianSongs,
      foreignSongs,
      rockSongs,
      otherGenreSongs,
      century20Songs,
      century21Songs,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';

.songs-lists {
  border-top: 1px solid #ebe9f1;
  padding-top: 1rem;
}

.songs-scroll {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 5px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 2px;
  }
}

.song-item {
  padding: 2px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

// Цвета для категорий
.text-russian {
  color: #28c76f;
}

.text-foreign {
  color: #7367f0;
}

.text-rock {
  color: #ff9f43;
}

.text-other {
  color: #00cfe8;
}

.text-century20 {
  color: #ea5455;
}

.text-century21 {
  color: #82868b;
}
</style>
